export default [

     {
          path: '/objective',
          name: 'Objective',
          component: () => import("@/views/Page/Objective/Objective.vue"),
           meta: {
               title: 'GRC | Objective',
          },
     }
];